/** Shared registration for the baked boa coil and its real tree support. */
export const SNAKE_SUPPORT_OFFSET = .85;
export const SNAKE_MODEL_TO_TILE = 22 * Math.SQRT1_2 / 96 * 1.15;
export const SNAKE_WRAP_SECONDS = 5;
